import { render, staticRenderFns } from "./PatientInvitationModal.vue?vue&type=template&id=486c8808&"
import script from "./PatientInvitationModal.vue?vue&type=script&lang=ts&"
export * from "./PatientInvitationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports